// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3c1Hg","content":"RecentSearches_content__kaevs"};